module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image5-74a869a41407408d8c9391c4fedb5d1f.png";